import { checkEmployeeHierarchy } from "@/api/utils"
import { OpenFolderButton } from "@/components/Buttons"
import { RFIProps } from "@/interfaces/rfi_types"
import { useAuth } from "@/App"
import { HandleDelete, HandleClose, HandleEmail, EditRFIButton } from "@/components/_Shared/Buttons/RFIRow"

// The expandable row for the RFIs table
export function RFIRow({ data }: { data: RFIProps }) {
    const { user } = useAuth()

    if (!user) {
        return <div>Loading...</div>
    }

    const encoded_rfi_id = encodeURIComponent(data.RFI_id ?? "")
    const roleHierarchy = checkEmployeeHierarchy(user.role)

    return (
        <div className="flex gap-2 ml-2">
            <EditRFIButton rfi_id={encoded_rfi_id} />
            <HandleClose data={data} />
            <HandleEmail data={data} />
            {(roleHierarchy === "MANAGERS" || roleHierarchy === "ADMIN" || roleHierarchy === "IT") && <HandleDelete data={data} />}
            <OpenFolderButton folder_path={data.folder_location ?? ""} folder_name="Open RFI Folder" />
            <OpenFolderButton folder_path={data.parent_project_folder_location ?? ""} folder_name="Open Project Folder" />
        </div>
    )
}
